export const colors = {
  mainBg: '#000000',
  layoutBg: 'rgb(64, 64, 64)',
  modalBg: 'rgba(0, 0, 0, 0.95)',
  bottomTabBg: '#162929',
  whiteText: '#F5F5F5',
  lightText: '#FAFAFA',
  darkText: 'rgba(255, 255, 255, 0.3)',
  registered: 'rgba(255, 255, 255, 0.15)',
  settings_border: 'rgba(255, 255, 255, 0.1)',
  settings_bg: '#162929',
  deposit_bg: '#0D282B',
  activeDarkText: '#0F8300',
  activeText: '#209D00',
  warningText: '#D90000',
  blueText: '#2E75BA',
  greenText: '#91c859',
  newGreenText: '#27E9A6',
  inActiveBtnBg: '#5b5b5b',
  inActiveBtnText: '#7b7b7b',
  inputBorder: '#588396',
  popupDangerPrimary: '#FF6262',
  popupDropBg: 'rgba(0, 0, 0, 0.5)',
  popupBorder: '#B1D5EA',
  popupPrimaryButtonBg: '#209D01',
  blue: 'rgba(46, 117, 186, 0.5)',
  primary: '#219C02',
  darkOverlay: 'rgba(0, 0, 0, 0.9)',
  deepBlue: '#19436C',
  lightBlue: '#85BED1',
  bg_contest: '#08121D',
  darkYellow: '#FABF41',
  lightYellow: '#FAFF00',
  unselect: '#585858',
  unselectDark: 'rgba(88, 88, 88, 0.5)',
  amount: '#143352',
  gray: 'rgba(255, 255, 255, 0.5)',
  newGreen: '#10884D',
  newDangerText: '#FF6565',
  iconColor: '#2791B5',
  darkNewGreen: 'rgba(28, 231, 131, 0.5)',
  balanceColor: '#03FF83',
  btn_bg_color: '#07111C',
  white: '#FFFFFF',
  mainBackground: '#0B1321',
  filter_chip_bg: '#8E93FF',
  filter_chip_bg2: 'rgba(0, 123, 193, 0.1)',
  disable_chip_text: '#92C0DB',
  disable_chip: '#004065',
  filter_modal_bg: 'rgba(0, 0, 0, 0.7)',
  id_text: '#CBCBCB',
  status_border: '#005C09',
  availability: '#006F39',
  caret: '#3BFF2E',
  state_color: '#006F38',
  state_completed: '#7F7F7F',
  state_cancelled: '#FF0000',
  divider_bg: '#545A64',
  pay_table_border: '#2A3446',
  stop_auto_play: '#2F3642',
  placeholder: '#808080',
  newLightBlue: '#8ab4f8',
  loading_login: '#0E1919',
  new_input_color: '#162929',
  new_bg: 'rgba(14, 24, 25, 1)',
  help_icon: 'rgba(0, 77, 67, 0.5)',
  darkPurple: '#6262D9',
  newDarkBlue: '#121D31',
  selectPurple: 'rgba(98, 98, 217, 0.5)',
  navSelected: '#004D43',
  balance: '#85BED0',
  yellow: '#FF6',
  enterCode: '#EBFFF7',
  green: 'rgba(10, 98, 76, 1)',
  purple: 'rgba(61, 61, 153, 1)',
  yellowText: 'rgba(208, 254, 113, 1)',
  rankColor: '#B6F2F2',
};
